export default __webpack_public_path__ + "static/media/close_black.61e66f0a.svg";